module.exports = __webpack_public_path__ + "img/d.2aac9787.png";